/* eslint-disable max-len */
import React from 'react';

export const FileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path
      fill="currentColor"
      d="m15,14a1,1 0 0 1 -1,1l-9,0a1,1 0 0 1 -1,-1l0,-2.715c0,-0.11 0.09,-0.2 0.2,-0.2l0.6,0c0.11,0 0.2,0.09 0.2,0.2l0,2.715l9,0l0,-2.715c0,-0.11 0.09,-0.2 0.2,-0.2l0.6,0c0.11,0 0.2,0.09 0.2,0.2l0,2.715zm-5,-9.177l0,7.062a0.2,0.2 0 0 1 -0.2,0.2l-0.6,0a0.2,0.2 0 0 1 -0.2,-0.2l0,-7.05l-2.293,2.275a0.2,0.2 0 0 1 -0.283,0l-0.424,-0.425a0.2,0.2 0 0 1 0,-0.283l3.366,-3.342a0.2,0.2 0 0 1 0.283,0l3.351,3.342a0.2,0.2 0 0 1 0,0.283l-0.424,0.425a0.2,0.2 0 0 1 -0.283,0l-2.293,-2.287z"
    />
  </svg>
);
